import { render, staticRenderFns } from "./Tenanttenant.vue?vue&type=template&id=78c36a50"
import script from "./Tenanttenant.vue?vue&type=script&lang=js"
export * from "./Tenanttenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports